<template>
  <div class="accordion-social" id="accordion-social">
    <draggable
      class="list-group"
      tag="ul"
      handle=".handle"
      v-model="list"
      v-bind="dragOptions"
      @start="onStartDragging"
      @end="onEnd">
      <transition-group type="transition" name="flip-list">
        <accordion-social-item v-for="item in networks"
                            :blocking="blocking"
                            :length="list.length"
                            :mode="mode"
                            :last="list[networks.length-1].sub_id"
                            :lastActive="last"
                            :elem="item"
                            :isUpdate="isUpdate"
                            @update_data="update_statuses($event)"
                            @updateSortOnAdd="updateSortForOneStep"
                            @removeBotTokenChannelErrors="removeChannelErrors"
                            @removeBotTokenErrors="removeErrors"
                            @remove_errors_by_id="removeErrorsById"
                            :errors="errors"
                            :key="item.sub_id">
        </accordion-social-item>
      </transition-group>
    </draggable>
  </div>
</template>
<style scoped lang="scss">;
.flip-list-move{
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
<script>
import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue"
import UrlBlock from "@/components/UrlBlock/UrlBlock.vue"
import AccordionSocialItem from "@/components/AccordionSocial/AccordionSocialItem/AccordionSocialItem.vue"
import draggable from "vuedraggable"

export default {
  name: "AccordionSocial",
  props: ["old", "startSteps", "blocking", "isUpdate", "mode", "errors"],
  components: {
    CustomCheckBox,
    UrlBlock,
    AccordionSocialItem,
    draggable
  },
  data() {
    return {
      networks: this.$props.old,
      dragging: false,
      last: this.$props.old.length,
    }
  },
  created() {
  },
  methods: {
    removeErrors() {
      this.$emit('remove_errors')
    },
    removeChannelErrors() {
      this.$emit('remove_channel_errors')
    },
    removeErrorsById(event) {
      this.$emit('remove_errors_by_id', event)
    },
    update_statuses(acc) {
      this.$emit('update_up', acc)
    },
    contains(elem, arr) {
      let last
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === elem) {
          return false;
        }
      }
      return true;

    },
    onEnd(event) {
      this.isDragging = false;
      let oldIndex = event.oldIndex;
      let newIndex = event.newIndex;
      let selected = this.selectedGates();
      if (oldIndex > 0) {
        this.constructSwitch(selected, newIndex, oldIndex);
      } else {
        this.constructSwitch(selected, oldIndex, newIndex);
      }
      this.list.map((item, key) => {
        item.sort = key;
        if (item.sub_id === this.list[newIndex].sub_id) {
          this.list[newIndex].sort = newIndex
        }
      });
      this.updateSortSteps()
    },
    updateSortForOneStep(payload) {
      // console.log(payload);
      this.list.map((item, key) => {
        item.sort = key;
      });
      this.updateSortSteps()
    },
    updateSortSteps() {
      this.$emit('updateSortSteps', this.list);
    },
    onStartDragging(event) {
      this.isDragging = true;
    },
    updateTypeOnDrag() {

    },
    selectedGates() {
      let active = this.list.filter(item => item.status === true);
      return active;
    },
    constructSwitch(arrGates, indexMain, indexExtra) {
      if (this.list[indexExtra].check.type === 'Or') {
        if (indexExtra === (arrGates.length - 1) || this.list[indexMain].check.type === 'And') {
          this.list[indexExtra].check.type = 'And';
        }
        this.list[indexMain].check.type = 'Or';
      }
      else if (this.list[indexExtra].check.type === 'And') {
        // console.log(this.list[indexMain].check.type);
        // console.log(indexExtra);
        if (indexExtra === (arrGates.length - 1) && this.list[indexMain].check.type === 'Or') {
          this.list[indexExtra].check.type = 'Or';
        }
        this.list[indexMain].check.type = 'And';
      }
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "name",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    list: {

      get: function () {
        let lastActiveItemId = 0
        let arrActiveItems = []
        this.networks.map(item => {
          if ((item.check.inputs.length > 0 && item.icon !== 'messenger') || (item.status && item.check.fillable === false)) {
            lastActiveItemId = item.sub_id
            arrActiveItems.push(item)
          }
        })
        this.networks.forEach(item => {
          let checkItem = this.contains(item, arrActiveItems)
          if (checkItem) {
            arrActiveItems.push(item)
          }
        })
        this.last = lastActiveItemId
        this.networks = arrActiveItems
        this.$emit('steps', this.networks)
        return this.networks
      },
      set: function (newValue) {
        this.networks = newValue
        localStorage.newPageSteps = JSON.stringify(this.networks)
      }

    }


  },
}

</script>